import { render, staticRenderFns } from "./AddKeywords.pug?vue&type=template&id=57ff68c2&lang=pug&external"
import script from "./AddKeywords.js?vue&type=script&lang=js&external"
export * from "./AddKeywords.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports